import { Box, Typography } from "@mui/material";
import React, { FC } from "react";

interface EmptyDataProps {
  text: string;
}

export const EmptyData: FC<EmptyDataProps> = ({ text }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "24px",
        height: "400px",
      }}
    >
      <Typography sx={{ color: "#9DA4AE" }}>{text}</Typography>
    </Box>
  );
};
